import React from 'react';

const Empty = () => (
  <div className="content">
  
  </div>);

export default Empty;
